import { enStatus, IAuthor } from './course';

export interface IDownload {
  created_at: string;
  file_url: string;
  extension: string;
  file_name: string;
  id_lesson: number;
  id_lesson_file: number;
  mimeType: string;
  size: any;
  title: string;
}

export interface ISavedLesson {
  course_hash: string;
  course_title: string;
  course_image: string;
  id: number;
  image: string;
  new_image?: string;
  release: string;
  status: enStatus;
  title: string;
  author: IAuthor;
  total_modules: number;
}

export interface ILessonControl {
  lesson: number;
  module: number;
  title: string;
}

export interface ILastLessonWatch {
  id: number;
  watched: boolean;
  status: enStatus;
}
export enum enContentType {
  LOADING = 0,
  YOUTUBE_VIMEO = 1,
  EMBED = 2,
  AOVIVO = 3,
  TEXT = 4,
  AUDIO = 5,
  VIDEOZZ = 6,
  FABRICA_PROVAS = 7,
  TOPIC = 8,
  SAFE_VIDEO = 9
}

export interface IRating {
  avg: number;
  user_rating: number;
}

export interface IContent {
  id?: number;
  type: { id: enContentType; name?: string };
  content?: string;
  embed?: string;
  drm_active?: number;
  download_enabled?: number | boolean;
  topic?: any;
}
export interface ILesson {
  id: number;
  id_course: number;
  id_module: number;
  hash_course: string;
  title: string;
  image?: string;
  short_description: string;
  new_image: string;
  new_description: string;
  course_title: string;
  contents: IContent[];
  expired_at: string | null;
  disable_comments: boolean;
  disable_talk_to_producer: boolean;
  chats: any;
  next: ILessonControl;
  previous: ILessonControl;
  can_reply: boolean;
  watched: boolean;
  author: IAuthor;
  lesson_type: {
    id: number;
    name: string;
  };
  status: enStatus;
  release: string;
  expire_at: string;
  has_file: boolean;
  description: string;
  description_type: string;
  iframe_url: string;
  iframe_config: string;
  lesson_files: IDownload[];
  allow_multiple_access: boolean;
}
